import { render } from "./EQRCDashboardTabs.vue?vue&type=template&id=de329158"
import script from "./EQRCDashboardTabs.vue?vue&type=script&lang=js"
export * from "./EQRCDashboardTabs.vue?vue&type=script&lang=js"

import exportComponent from "/chi/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__